import React from 'react';
import { Flex, HStack, Switch, FormLabel } from '@chakra-ui/react';
import { useTableDensity } from '../../context/TableDensityContext';

export default function FilterBar({ children, showDensityToggle = false, ...props }) {
  const { density, setDensity } = useTableDensity();
  const isCompact = density === 'compact';
  return (
    <Flex align="center" justify="space-between" mb={6} wrap="wrap" gap={4} {...props}>
      {children}
      {showDensityToggle && (
        <HStack spacing={2} align="center">
          <FormLabel htmlFor="density-toggle" m={0} fontSize="sm" color="gray.600">Compact</FormLabel>
          <Switch id="density-toggle" size="sm" isChecked={isCompact} onChange={e => setDensity(e.target.checked ? 'compact' : 'comfortable')} />
        </HStack>
      )}
    </Flex>
  );
}


